/* ============
 * Templates Mutations Types
 * ============
 *
 * The mutations available for the templates module.
 */

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export default {
  SET_CURRENT_PAGE,
};



// WEBPACK FOOTER //
// ./src/store/modules/templates/types.js